export default {
  generateTeamViewUri(teamsUri) {
    const parsedArray = this.parseTeamsUri(teamsUri);

    if (parsedArray) {
      if (teamsUri.startsWith("msteams")) {
        return `msteams://teams.microsoft.com/l/team/${parsedArray[1]}/conversations?groupId==${parsedArray[2]}&tenantId=${parsedArray[3]}`;
      } else {
        return `https://teams.microsoft.com/_?tenantId=${parsedArray[3]}#/school/conversations/Generel?groupId=${parsedArray[2]}&threadId=${parsedArray[1]}&ctx=channel`;
      }
    }
    return teamsUri;
  },

  generateFileViewUri(teamsUri) {
    const parsedArray = this.parseTeamsUri(teamsUri);

    if (parsedArray) {
      // https://teams.microsoft.com/_?tenantId=01825817-ad59-4b45-ab7a-464400d881ae#/school/files/Generel?threadId=19:4EwcVQQST78gQkEVyJ5wI40bcd0ssU2Ib13KwUU_7i81@thread.tacv2&ctx=channel
      //return `https://teams.microsoft.com/_?tenantId=${parsedArray[3]}#/school/files/Generel?groupId=${parsedArray[2]}&threadId=${parsedArray[1]}`;
      return `https://teams.microsoft.com/_?tenantId=${parsedArray[3]}#/school/files/Generel?threadId=${parsedArray[1]}&ctx=channel`;
    }
    return teamsUri;
  },

  parseTeamsUri(teamsUri) {
    //https://teams.microsoft.com/_#/school/files/Generel?groupId=48a99c3f-2a60-42fa-a301-0b15506fcab8&threadId=19:0f200a0a70c44e4bba150cf7f30ad8db@thread.tacv2&ctx=channel

    const regex = /team\/([\s\S\d\D]*?)\/conversations\?groupId=([\s\S\d\D]*?)&tenantId=([\s\S\d\D]*?)$/gim; // https://regex101.com/r/OUDQaW/1
    let check = regex.exec(teamsUri);

    if (!check || check.length < 4) {
      return null;
    }
    return check;
  }
};
